<script>
  import MovingStar from "./Minor/MovingStar.svelte";
  import RandomStar from "./Minor/RandomStar.svelte";
  import Logo from "./Icons/Logo.svelte";
</script>

<div class="hero">
  <div class="stars-container">
    <MovingStar />
    <MovingStar />
    <MovingStar />
    <MovingStar />
    <MovingStar />
    <MovingStar />
    <RandomStar style={"fill: white; opacity: .5; z-index: 1;"} />
    <RandomStar style={"fill: white; opacity: .5; z-index: 1;"} />
    <RandomStar style={"fill: white; opacity: .5; z-index: 1;"} />
    <RandomStar style={"fill: white; opacity: .5; z-index: 1;"} />
    <RandomStar style={"fill: white; opacity: .5; z-index: 1;"} />
    <RandomStar style={"fill: white; opacity: .5; z-index: 1;"} />
    <RandomStar style={"fill: white; opacity: .5; z-index: 1;"} />
    <RandomStar style={"fill: white; opacity: .5; z-index: 1;"} />
  </div>
  <div class="content">
    <h1>
      <span class="one">An Interactive</span>
      <br />
      <span class="two">History of</span>
      <br />
      <span class="three">Impact</span>
      <br />
      <span class="four">Investing</span>
    </h1>
    <h2>
      By​ <a
        class="styled-link bold with-logo"
        href="https://www.collaborativefund.com/"
        target="_blank"
        >Collaborative Fund
        <Logo /></a
      >
    </h2>
    <h3>
      With assistance from <a
        style="color: white !important"
        href="https://www.mokshadata.com/"
        target="_blank">Moksha Data</a
      >
    </h3>

    <a href="#2021" class="circle"><h4>Scroll right →</h4></a>
  </div>
</div>

<style>
  :global(.first, .last) {
    width: 80%;
    z-index: 0;
    transform: translate3d(0, 0, 0px);
  }

  @media screen and (max-width: 767px) {
    :global(.first, .last) {
      width: 95% !important;
    }
  }

  @media screen and (max-width: 467px) {
    :global(.first, .last) {
      width: 100% !important;
      /* z-index: 2; */
    }
  }

  .hero {
    height: 100%;
    background: rgba(0, 0, 0, 0)
      linear-gradient(rgb(69, 119, 174) 0%, rgb(76, 81, 142) 100%) repeat scroll
      0% 0%;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
    text-align: center;
    position: relative;
  }

  .stars-container {
    position: absolute;
    width: 98%;
    height: 98%;
    pointer-events: none;
  }

  .content {
    margin-right: 10%;
  }

  .bold {
    font-weight: 900;
  }

  h1 {
    margin: 0;
    letter-spacing: 0;
    margin-bottom: 2rem;
    line-height: 0.9;
    font-weight: 400;
    font-family: var(--font-subhead);
    text-transform: uppercase;
    color: white;
    /* background: linear-gradient( to bottom right, rgb(147, 150, 171) 0%, white 50%, #b0baff 100% ); */
    background: linear-gradient(
      to top right,
      #16b1a9 -30%,
      #fff 50%,
      #f0b64f 130%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    user-select: none;
  }

  .one {
    font-size: 3.5rem;
  }

  .two {
    font-size: 4.95rem;
  }

  .three {
    font-size: 7.92rem;
  }

  .four {
    font-size: 5.45rem;
  }

  h2,
  h3 {
    text-align: center;
    font-family: var(--font-subhead);
  }

  h2 {
    font-weight: 300;
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }

  h3 {
    font-weight: 100;
    font-size: 1rem;
    margin-top: 0;
    letter-spacing: 0.4px;
  }

  h4 {
    font-size: 0.9rem;
    font-weight: 200;
    line-height: 1;
  }

  .circle {
    position: absolute;
    top: 5%;
    right: 5%;
    width: 85px;
    height: 85px;
    padding: 4px;
    line-height: 100px;
    border-radius: 50%;
    margin-left: auto;
    z-index: 10;
    color: white;
    text-align: center;
    background: #4b5490;
    display: flex;
    place-items: center;
    justify-content: center;
    border: 1px solid #4b5490;
    transition: all 300ms ease;
    animation: nudgeRight 2500ms ease-in infinite;
  }

  .circle {
    font-family: var(--font-subhead);
    font-weight: 300;
  }

  .circle:hover {
    text-decoration: none;
    border: 1px solid white;
  }

  @keyframes nudgeRight {
    0% {
      transform: translateX(0);
    }
    20% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(0);
    }
  }

  /* TABLET BREAKPOINT */
  /* @media screen and (max-width: 968px) {
    .hero {
      padding: 0;
    }

    .one {
      font-size: 2.6rem;
    }

    .two {
      font-size: 3.6rem;
    }

    .three {
      font-size: 5.8rem;
    }

    .four {
      font-size: 4rem;
    }

    h2 {
      font-size: 1.6rem;
    }
  } */

  /* MOBILE BREAKPOINT */
  @media screen and (max-width: 818px) {
    .one {
      font-size: 2.6rem;
    }

    .two {
      font-size: 3.65rem;
    }

    .three {
      font-size: 5.8rem;
    }

    .four {
      font-size: 4rem;
    }

    h2,
    h3 {
      text-align: center;
    }

    h2 {
      font-size: 1.3rem;
    }

    h3 {
      font-size: 0.9rem;
    }

    h4 {
      font-size: 0.65rem;
    }

    .content {
      margin-right: 0;
    }

    .circle {
      width: 60px;
      height: 60px;
    }
  }

  @media screen and (max-width: 450px) {
    .one {
      font-size: 1.9rem;
    }

    .two {
      font-size: 2.65rem;
    }

    .three {
      font-size: 4.25rem;
    }

    .four {
      font-size: 2.95rem;
    }

    h3 {
      font-size: 0.8rem;
    }

    /* .circle {
      bottom: 2.5%;
      right: 20%;
      top: unset;
      background: rgb(69, 119, 174);
    } */
  }
</style>
